<template>
  <div>
    <HeadingLv4 text="マイナビDOCTORへの同時登録" class="hpcr_heading" />
    <TextBlock class="textBlock">
      <p class="notes">
        「マイナビDOCTOR」は常勤求人からスポット求人、アルバイト求人まで、最新の医師求人情報をご紹介する転職支援サービスです。<br />
        研修中のアルバイトを検討いただく際にもぜひご利用ください。
      </p>
      <p class="textRight">
        <TextLink
          link="https://doctor.mynavi.jp/"
          text="詳細はこちら"
          blank
          small
          iconTarget
        />
      </p>
    </TextBlock>
    <TextBlock class="textFooter">
      <p class="textCenter">
        <TextLink
          link="https://doctor.mynavi.jp/kiyaku/"
          text="利用規約"
          blank
          small
          iconTarget
        />
        |
        <TextLink
          link="https://doctor.mynavi.jp/privacy/"
          text="プライバシーポリシー"
          blank
          small
          iconTarget
        />
      </p>
    </TextBlock>
  </div>
</template>

<script lang="ts">
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import TextLink from '@/components/elements/TextLink.vue'

export default {
  name: 'DoctorRegister',

  components: {
    HeadingLv4,
    TextBlock,
    TextLink
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hpcr_heading {
  margin-bottom: 20px;
}

.textBlock {
  margin-bottom: 28px;
}
.textFooter {
  margin-bottom: 16px;
}

.textRight {
  text-align: right;
}
.textCenter {
  text-align: center;
}
</style>
